module.exports = __webpack_public_path__ + "img/logo.a5549b12.png";